export default __webpack_public_path__ + "static/media/News-2.3bee3d98.jpg";